import React from "react";
import { connect } from "react-redux";
import { List, Button, Tabs, Popover, Popup, TextArea } from 'devextreme-react';
import Moment from "moment";
import { loading, loadDataGrid, deleteSchedule, rejectSchedule, deleteScheduleWorker } from "../actions"
import { showToastError, showMessageApi } from "../../../../Main/actions";
import { SaveSchedule } from "../../../../../services/solicitudesAgendaSelApi";
import trace from "../../../../../helpers/trace";
import { formatDateForFilter } from "../../../../../helpers/dateFormat";

class nuevaGestionColumnaIzq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {    
      selectedIndex: 0,
      tootipBaterias: false,
      tooltipExamenes: false,
      tooltipAyuda: false,
      selectedItemKeys: [],
      selectedItems: null,
      selectedSolicitudState: null,
      confirmSavePopup: false,
      confirmCancelPopup: false,
      popoverSaveDiscard: false,
      rejectSavePopup: false,
      rejectModal: false,
      textAreaRejectModal: ""
    };
    this.onTabsSelectionChanged = this.onTabsSelectionChanged.bind(this);
  }

  onTabsSelectionChanged = (args) => {    
    if(args.name == 'selectedIndex' && args.element.id === "tabInboxAgendamiento" && args.value >= 0) {
      this.setState({
        selectedIndex: args.value
      });
    }
  }

  componentDidMount= () =>{
    const {
      Workers,
      Pools,
      PsychologicalExams
    } = this.props.selectedSolicitud
    const firstPool = Pools && Pools.length > 0 && Pools[0]
    const firstCiel = PsychologicalExams && PsychologicalExams.length > 0 && PsychologicalExams[0]
    let trabajadoresPendientes = [];
    if(firstCiel && firstPool){
      trabajadoresPendientes = Workers && Workers.length && Workers.filter(e => e.SchedulingDates && e.SchedulingDates.length < 2)
    }else{
      trabajadoresPendientes = Workers && Workers.length && Workers.filter(e => e.SchedulingDates && e.SchedulingDates.find(ee => ee.QuotaType === 0 ))
    }
    const workerSelected = (this.state.selectedItems) || (trabajadoresPendientes.length && trabajadoresPendientes[0])
    this.props.onWorkerSelected(workerSelected)
  }

  loadDataGrid = () =>{
    const data = {
      from: formatDateForFilter(Moment().subtract(1, "year")),
      to: formatDateForFilter(Moment()),
      companyRut: this.props.companyId,
      PetitionerRut: this.props.userData.RUT,
      StatusId: this.props.selectedTipoSolicitud.value.value,
    };
    this.props.dispatch(loadDataGrid(data));
  }

  componentDidUpdate = (prevData)=>{
    if(this.props.selectedSolicitud && !this.state.selectedSolicitudState)
      this.setState({selectedSolicitudState: this.props.selectedSolicitud})
    if(prevData.selectedSolicitud.Workers !== this.props.selectedSolicitud.Workers){
      const {
        Workers,
        Pools,
        PsychologicalExams
      } = this.props.selectedSolicitud
      const firstPool = Pools && Pools.length > 0 && Pools[0]
      const firstCiel = PsychologicalExams && PsychologicalExams.length > 0 && PsychologicalExams[0]
      let trabajadoresPendientes = [];
      if(firstCiel && firstPool){
        trabajadoresPendientes = Workers && Workers.length && Workers.filter(e => e.SchedulingDates && e.SchedulingDates.length < 2)
      }else{
        trabajadoresPendientes = Workers && Workers.length && Workers.filter(e => e.SchedulingDates && e.SchedulingDates.find(ee => ee.QuotaType === 0 ))
      }
      const workerSelected = (this.state.selectedItems) || (trabajadoresPendientes.length && trabajadoresPendientes[0])
      this.props.onWorkerSelected(workerSelected)
    }
  }

  handleDeleteSchedule = async() =>{    
    if(this.props.isLoading) return false;
    const {
      Pools,
      PsychologicalExams,
    } = this.props.selectedSolicitud
    const firstPool = Pools && Pools.length > 0 && Pools[0]
    const firstCiel = PsychologicalExams && PsychologicalExams.length > 0 && PsychologicalExams[0]
    const achsOffice = firstPool ? firstPool : (firstCiel ? firstCiel : null);
    await this.props.dispatch(deleteSchedule(this.props.selectedSolicitud, this.props.connectionHub, this.props.userData.RUT, achsOffice, this.props.close));
  }

  handleRemoveDate = async(data, quotaType) =>{ 
    if(this.props.isLoading) return false;   
    const {
      Pools,
      PsychologicalExams,
    } = this.props.selectedSolicitud
    const firstPool = Pools && Pools.length > 0 && Pools[0]
    const firstCiel = PsychologicalExams && PsychologicalExams.length > 0 && PsychologicalExams[0]
    const achsOffice = firstPool ? firstPool : (firstCiel ? firstCiel : null);
    await this.props.dispatch(deleteScheduleWorker(this.props.selectedSolicitud, data, this.props.connectionHub, this.props.userData.RUT, achsOffice, quotaType));
  }

  handleSaveSchedule = async() =>{    
    if(this.props.isLoading) return false;
    this.props.dispatch(loading(true));
    try {
      let message;
      const request = await SaveSchedule(this.props.selectedSolicitud.Id);
      if (request.status === 200) {        
        message = "La solicitud se ha reservado reservados.";
        this.props.dispatch(showMessageApi(message, request));
        this.props.close()
        this.loadDataGrid()
      } else {
        const result = await request.json();
        this.props.dispatch(showMessageApi(message, request, result));      
      }
      this.props.dispatch(showMessageApi(message, request));
    } catch (e) {
      trace.error("updateDataGestionar", e);
      this.props.dispatch(showToastError());
    }
    this.props.dispatch(loading(false));
  }

  handleRejectSchedule = async() =>{  
    if(this.props.isLoading) return false;  
    const _data = {
      RequestId: this.props.selectedSolicitud && this.props.selectedSolicitud.Id ? this.props.selectedSolicitud.Id : 0,
      RequestStatus: 9,
      Comment: this.state.textAreaRejectModal,
    };
    const {
      Pools,
      PsychologicalExams,
    } = this.props.selectedSolicitud
    const firstPool = Pools && Pools.length > 0 && Pools[0]
    const firstCiel = PsychologicalExams && PsychologicalExams.length > 0 && PsychologicalExams[0]
    const achsOffice = firstPool ? firstPool : (firstCiel ? firstCiel : null);
    await this.props.dispatch(rejectSchedule(_data, this.props.selectedSolicitud, this.props.connectionHub, this.props.close, this.loadDataGrid, this.props.userData.RUT, achsOffice));
    this.setState({ rejectModal: false, textAreaRejectModal: "" });   
  }

  handleCancel = () => {
    this.setState({ confirmCancelPopup: false });
  }

  render() {
    const {
      CompanyName,
      CompanyRut,
      CostCenter,
      AuthorizedName,
      PetitionerName,
      Pools,
      AdditionalExams,
      PsychologicalExams,
      RequestTypeDescription,
      Workers
    } = this.props.selectedSolicitud
    const firstPool = Pools && Pools.length > 0 && Pools[0]
    const tooltipPools = Pools && Pools.length > 1 && [...Pools.slice(1, Pools.length), ...AdditionalExams.map((e)=>{e.Description = e.ExamDescription; return e;})];
    const firstCiel = PsychologicalExams && PsychologicalExams.length > 0 && PsychologicalExams[0]
    const tooltipCiel = PsychologicalExams && PsychologicalExams.length > 1 && PsychologicalExams.slice(1, PsychologicalExams.length)
    const achsOffice = firstPool && firstPool.AchsOfficeDescription ? firstPool.AchsOfficeDescription : (firstCiel && firstCiel.AchsOfficeDescription ? firstCiel.AchsOfficeDescription : null);
    let trabajadoresPendientes = [];
    let trabajadoresAgendados = [];
    if(firstCiel && firstPool){
      //41 ciel // 1 sep
      trabajadoresPendientes = Workers && Workers.length && Workers.filter(e => e.SchedulingDates && e.SchedulingDates.length < 2)
      trabajadoresAgendados = Workers && Workers.length && Workers.filter(e => e.SchedulingDates && e.SchedulingDates.length === 2 && e.SchedulingDates.find(ee => ee.QuotaType !== 0 ))
    }else{
      trabajadoresPendientes = Workers && Workers.length && Workers.filter(e => e.SchedulingDates && e.SchedulingDates.find(ee => ee.QuotaType === 0 ))
      trabajadoresAgendados = Workers && Workers.length && Workers.filter(e => e.SchedulingDates && e.SchedulingDates.find(ee => ee.QuotaType !== 0 ))
    }
    const workerSelected = (this.state.selectedItems) || (trabajadoresPendientes.length && trabajadoresPendientes[0])
    return (
      <React.Fragment>
          <div className="row">
            <div className="col-12">
              <div className="contenedorEmpresa">
                <div className="row nombreEmpresa">
                  <div className="col-3">
                    <Button className={"return"} icon={'arrowleft'} onClick={()=> this.setState({confirmCancelPopup: true})} />
                    <Popup
                      className={'popup'}
                      visible={this.state.confirmCancelPopup}
                      onHiding={()=> this.setState({confirmCancelPopup: false})}
                      dragEnabled={false}
                      closeOnOutsideClick={true}
                      showTitle={true}
                      title={'Agendamiento cupos'}
                      width={600}
                      height={200}
                    >
                      <div className="row">
                        <div className="col-12" style={{textAlign: "center"}}>
                          Al volver se perderán los cupos seleccionados para cada trabajador.
                        </div>
                      </div>
                      <div className="row" style={{position: "absolute",bottom: "20px",width: "100%"}}>
                        <div className="col-6">
                          <Button type={"normal"} text={"Cancelar"} style={{float: "right"}} onClick={this.handleCancel}/>
                        </div>
                        <div className="col-6">
                          <Button type={"success"} text={"Aceptar"} onClick={this.handleDeleteSchedule} disabled={this.props.isLoading}/>
                        </div>
                      </div>                                                                   
                    </Popup>
                  </div>
                  <div className="col-6">
                    <h2>{CompanyName || ""}</h2>                      
                  </div>
                  <div className="col-3" style={{textAlign: "right"}}>
                    <Button id={"actionButtonCalendar"} className={"save"} icon={'todo'} onClick={()=>this.setState({popoverSaveDiscard: true})} />
                    <Popover
                      className={"popoverActionSaveDiscardInbox"}
                      target={'#actionButtonCalendar'}
                      position={'top'}
                      width={200}
                      visible={this.state.popoverSaveDiscard}
                      onHiding={()=> this.setState({popoverSaveDiscard: false})}
                    >
                      <div className="row">
                        <div className="col-12">
                          <Button className={"save"} text={"Agendar slicitud"} onClick={()=>this.setState({confirmSavePopup: true})} disabled={!!(trabajadoresPendientes && trabajadoresPendientes.length)} >
                            <i className="achs-icon"> m </i>
                            <span>Agendar solicitud</span>
                          </Button>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <Button className={"close"} text={"Rechazar solicitud"} onClick={()=>this.setState({rejectSavePopup: true})} >
                            <i className="achs-icon"> W </i>
                            <span>Rechazar solicitud</span>
                          </Button>
                        </div>
                      </div>                      
                    </Popover>
                    <Popup
                      className={'popup'}
                      visible={this.state.confirmSavePopup}
                      onHiding={()=> this.setState({confirmSavePopup: false})}
                      dragEnabled={false}
                      closeOnOutsideClick={true}
                      showTitle={true}
                      title={'Agendamiento cupos'}
                      width={600}
                      height={200}
                    >
                      <div className="row">
                        <div className="col-12" style={{textAlign: "center"}}>
                          ¿Quieres agendar los cupos seleccionados?
                        </div>
                      </div>
                      <div className="row" style={{position: "absolute",bottom: "20px",width: "100%"}}>
                        <div className="col-6">
                          <Button type={"normal"} text={"Cancelar"} style={{float: "right"}}/>
                        </div>
                        <div className="col-6">
                          <Button type={"success"} text={"Aceptar"} onClick={this.handleSaveSchedule} disabled={this.props.isLoading}/>
                        </div>
                      </div>                                                                   
                    </Popup>
                    <Popup
                      className={'popup'}
                      visible={this.state.rejectSavePopup}
                      onHiding={()=> this.setState({rejectSavePopup: false})}
                      dragEnabled={false}
                      closeOnOutsideClick={true}
                      showTitle={true}
                      title={'Agendamiento cupos'}
                      width={600}
                      height={200}
                    >
                      <div className="row">
                        <div className="col-12" style={{textAlign: "center"}}>
                          ¿Quieres rechazar la solicitud?
                        </div>
                      </div>
                      <div className="row" style={{position: "absolute",bottom: "20px",width: "100%"}}>
                        <div className="col-6">
                          <Button type={"normal"} text={"Cancelar"} style={{float: "right"}}/>
                        </div>
                        <div className="col-6">
                          <Button type={"success"} text={"Aceptar"} onClick={this.handleRejectSchedule}/>
                        </div>
                      </div>                                                                   
                    </Popup>
                  </div>                    
                </div>
                <div className="row tipoEvaluacion">
                  <div className="col-9">
                    <h4>{RequestTypeDescription || ""}</h4>
                  </div>
                  <div className="col-3" style={{textAlign: "right"}}>
                    <Button id={"tituloAyuda"} className={"help"} icon={'help'} onClick={() => this.setState({tooltipAyuda : true})}/>
                    <Popover
                      target={'#tituloAyuda'}
                      position={'top'}
                      width={300}
                      visible={this.state.tooltipAyuda}
                      onHiding={()=> this.setState({tooltipAyuda: false})}
                      shading={false}    
                      className="popoverNuevaGestionCompañia"                                        
                    >
                      <div className="row">
                        <div className="col-12">
                          <h3 className=""><p>Rut Empresa</p></h3>
                          <span><strong>{CompanyRut || ""}</strong></span>
                        </div>
                        <div className="col-12">
                          <h3 className=""><p>Centro de costos</p></h3>
                          <span><strong>{CostCenter || ""}</strong></span>
                        </div>
                        <div className="col-12">
                          <h3 className=""><p>Aprobador</p></h3>
                          <span><strong>{AuthorizedName || ""}</strong></span>
                        </div>
                        <div className="col-12">
                          <h3 className=""><p>Solicitante</p></h3>
                          <span><strong>{PetitionerName || ""}</strong></span>
                        </div>
                      </div>
                    </Popover>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="row descripcionSolicitud">
                <h3>{achsOffice || ""}</h3>
                <div className={"contenedor_pools"}>
                  {firstPool && <span className="span_pools">{(firstPool.Description.length > 25 ? firstPool.Description.substring(0,25) + "..." : firstPool.Description ) || ""}</span>}
                  {tooltipPools && <React.Fragment>
                    <span id="masBaterias" className="span_pools" onClick={() => this.setState({tootipBaterias : true})}>{tooltipPools.length} más</span>
                    <Popover
                      target={'#masBaterias'}
                      position={'top'}
                      width={300}
                      visible={this.state.tootipBaterias}
                      onHiding={()=> this.setState({tootipBaterias: false})}
                      shading={false}                                            
                    >                      
                      <List
                        focusStateEnabled={false}
                        hoverStateEnabled={false}
                        activeStateEnabled={false}
                        dataSource={tooltipPools.map(e=> e.Description)}/>
                    </Popover>
                  </React.Fragment>}                    
                </div>
                <div className={"contenedor_exams"}>
                  {firstCiel && <span className="span_exams">{(firstCiel.ExamDescription.length > 25 ? firstCiel.ExamDescription.substring(0,25) + "..." : firstCiel.ExamDescription ) || ""}</span>}
                  {tooltipCiel && <React.Fragment>
                    <span id="masExamen" className="span_exams" onClick={() => this.setState({tooltipExamenes : true})}>{tooltipCiel.length} más</span>
                    <Popover
                      target={'#masExamen'}
                      position={'top'}
                      width={300}
                      visible={this.state.tooltipExamenes}
                      onHiding={()=> this.setState({tooltipExamenes: false})}
                      shading={false}                                            
                    >
                      <List
                        focusStateEnabled={false}
                        hoverStateEnabled={false}
                        activeStateEnabled={false}
                        dataSource={tooltipCiel.map(e => e.ExamDescription)}/>
                    </Popover>
                  </React.Fragment>}
                  
                </div>            
                      
              </div>
            </div>
            <div className="col-12">
            <Tabs
              id="tabInboxAgendamiento"
              dataSource={[
                { text: 'Pendientes ' + (trabajadoresPendientes && trabajadoresPendientes.length ? " ("+trabajadoresPendientes.length+")" : "") },
                { text: 'Reservados ' + (trabajadoresAgendados && trabajadoresAgendados.length ? " ("+trabajadoresAgendados.length+")" : "") }
              ]}
              selectedIndex={this.state.selectedIndex || 0}
              onOptionChanged={this.onTabsSelectionChanged}
              scrollByContent={false}
              showNavButtons={false}
              focusStateEnabled={false}
              hoverStateEnabled={false}
              activeStateEnabled={false}
            />
            {this.state.selectedIndex === 0 && <List
              className={"contenedorTrabajadores pendientes"}
              dataSource={trabajadoresPendientes}
              selectionMode= "single"
              focusStateEnabled={false}
              activeStateEnabled={false}                
              height={'38vh'}
              selectedItems={[workerSelected]}
              onSelectionChanged={(e)=>{
                this.setState({selectedItems:e.addedItems[0]},() => {
                  this.props.onWorkerSelected(e.addedItems[0])
                })
              }}
              onItemClick={(e)=>{
                if(e.event.toElement.className === "icon-remove" && !this.props.isLoading){
                  e.event.preventDefault()
                  e.event.stopPropagation()
                  if(e.event.toElement.attributes["data-type"] && e.itemData)
                    this.handleRemoveDate(e.itemData, Number(e.event.toElement.attributes["data-type"].value))
                  return false
                }
              }}
              itemRender={(item) => {
                let dateSEP = item.SchedulingDates.find(e => e.QuotaType === 1);
                let dareCIEL = item.SchedulingDates.find(e => e.QuotaType === 41);
                return <div className={"itemTrabajador"}>              
                  <div><strong>{item.Name || ""}</strong> - {item.DocumentNumber}</div>
                  {firstPool && <div className={"contenedorFecha"}>
                    Sep: 
                    {dateSEP ? 
                    <span > {Moment(dateSEP.Date).format("dddd DD [de] MMMM, HH:mm")} <div onClick={(e)=>this.handleRemoveDate(item, 1)} className={"icon-remove"} data-type={1} ></div></span>: 
                    ""}
                  </div>}
                  {firstCiel && <div className={"contenedorFecha"}>
                    Ciel: 
                    {dareCIEL ? 
                    <span > {Moment(dareCIEL.Date).format("dddd DD [de] MMMM, HH:mm")} <div onClick={(e)=>this.handleRemoveDate(item, 41)} className={"icon-remove"} data-type={41} ></div></span>: 
                    ""}
                  </div>}
                </div>
              }} />}

              {this.state.selectedIndex === 1 && trabajadoresAgendados.length > 0 && <List
              className={"contenedorTrabajadores agendados"}
              dataSource={trabajadoresAgendados || []}
              selectionMode= "single"
              focusStateEnabled={false}
              activeStateEnabled={false}
              height={'38vh'}
              itemRender={(item) => {
                let dateSEP = item.SchedulingDates.find(e => e.QuotaType === 1);
                let dareCIEL = item.SchedulingDates.find(e => e.QuotaType === 41);
                return <div className={"itemTrabajador"}>              
                  <div><strong>{item.Name || ""}</strong> - {item.DocumentNumber}</div>
                  {firstPool && <div className={"contenedorFecha"}>
                    Sep: 
                    {dateSEP ? 
                    <span> {Moment(dateSEP.Date).format("dddd DD [de] MMMM, HH:mm")} <div onClick={(e)=>this.handleRemoveDate(item, 1)} className={"icon-remove"} ></div></span>: 
                    ""}
                  </div>}
                  {firstCiel &&<div className={"contenedorFecha"}>
                    Ciel: 
                    {dareCIEL ? 
                    <span> 
                    {Moment(dareCIEL.Date).format("dddd DD [de] MMMM, HH:mm")} <div onClick={(e)=>this.handleRemoveDate(item, 41)} className={"icon-remove"} ></div></span>: 
                    ""}
                  </div>}
                </div>
              }} />}
              {this.state.selectedIndex === 1 && trabajadoresAgendados.length === 0 && <React.Fragment>
                <div className={"agendadoSinCupo"}>
                  No hay cupos reservados.
                </div>
                </React.Fragment> }
            </div>
          </div>
          <Popup
            visible={this.state.rejectModal}
            showTitle
            title="Gestionar solicitud"
            onHiding={() => this.setState({ rejectModal: false })}
            maxWidth={500}
            maxHeight={300}
            dragEnabled={false}
            style={{ borderBottom: 0 }}
            className="modalGestionarSolicitud"
          >
            <div>
              <div className="row">
                <div className="col-12">
                  <h3><p className="text-left">Razón del rechazo de la solicitud</p></h3>
                  <TextArea
                    height={120}
                    maxLength={200}
                    value={this.state.textAreaRejectModal}
                    valueChangeEvent="keyup"
                    onValueChanged={(v) => this.setState({ textAreaRejectModal: v.value })}
                  />
                </div>
              </div>
              <div className="row bottom-button">
                <div className="col-6">
                  <Button
                    onClick={() => this.setState({ rejectModal: false })}
                    type="danger"
                    text="Cancelar"
                    disabled={this.props.isLoading}
                  />
                </div>
                <div className="col-6">
                  <Button
                    onClick={() => this.rejectSolicitud()}
                    type="success"
                    text="Enviar"
                    disabled={!this.state.textAreaRejectModal.trim().length || this.props.isLoading}
                  />
                </div>
              </div>
            </div>
          </Popup>
      </React.Fragment>
    );
  }
}


const mapStateToProps = (state) => ({
  isLoading: state.inboxSolicitudes.isLoading,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  userData: state.global.userData,
  selectedSolicitud: state.inboxSolicitudes.selectedSolicitud,
  selectedTipoSolicitud: state.inboxSolicitudes.selectedTipoSolicitud,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(nuevaGestionColumnaIzq);

